import moment from "moment";
import DatePicker from "react-datepicker";
import {
    Badge,
    Button,
    Col,
    Form,
    OverlayTrigger,
    Tooltip,
} from "react-bootstrap";
import { Filter, X } from "react-feather";

import { AsyncPaginate } from "react-select-async-paginate";
import { getSapUnpaidInvoiceCompanies } from "../hooks/api";

export const SapUnpaidInvoiceSearch = ({
    setSearchValue,
    searchValue,
    search,
}) => {

    const loadOptions = async (search, loadedOptions, { page }) => {
        const response = await getSapUnpaidInvoiceCompanies({
            search,
            page,
        });

        return {
            options: response.data.map((company) => ({
                value: company.bp_code,
                label: company.bp_name,
            })),
            hasMore: response.has_more,
            additional: {
                page: page + 1,
            },
        };
    };

    return (
        <>
            <Col md={3}>
                <Form.Label>Company </Form.Label>
                <AsyncPaginate
                    className="render-above"
                    loadOptions={loadOptions}
                    additional={{ page: 1 }}
                    placeholder="Search Company"
                    isClearable
                    onChange={(value) =>
                        setSearchValue({
                            ...searchValue,
                            company: value ? value.value : "",
                        })
                    }
                />
            </Col>

            <Col md={3}>
                <Form.Label>BP Ref No.</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Enter BP Ref No."
                    value={searchValue.bp_ref_no || ""}
                    onChange={(e) =>
                        setSearchValue({
                            ...searchValue,
                            bp_ref_no: e.target.value,
                        })
                    }
                />
            </Col>

            <Col md={2}>
                <Form.Label>From Due Date</Form.Label>
                <DatePicker
                    className="form-control"
                    selected={
                        searchValue.start_due_date
                            ? moment(
                                  searchValue.start_due_date,
                                  "YYYY-MM-DD"
                              ).toDate()
                            : null
                    }
                    onChange={(date) =>
                        setSearchValue({
                            ...searchValue,
                            start_due_date: date
                                ? moment(date).format("YYYY-MM-DD")
                                : null,
                        })
                    }
                />
            </Col>

            <Col md="auto" className="align-self-end">
                <Badge bg="info" className="px-3 py-2">
                    To
                </Badge>
            </Col>

            <Col md={2}>
                <Form.Label>To Due Date</Form.Label>
                <DatePicker
                    className="form-control"
                    selected={
                        searchValue.end_due_date
                            ? moment(
                                  searchValue.end_due_date,
                                  "YYYY-MM-DD"
                              ).toDate()
                            : null
                    }
                    onChange={(date) =>
                        setSearchValue({
                            ...searchValue,
                            end_due_date: date
                                ? moment(date).format("YYYY-MM-DD")
                                : null,
                        })
                    }
                />
            </Col>

            <Col md="auto" className="align-self-end">
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-search">Search filter</Tooltip>
                    }
                >
                    <Button
                        className="me-2"
                        variant="info"
                        onClick={() => search({ page: 1 })}
                    >
                        <Filter size={15} />
                    </Button>
                </OverlayTrigger>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-reset">Reset filters</Tooltip>
                    }
                >
                    <Button
                        variant="secondary"
                        onClick={() => {
                            const resetValues = {
                                company: "",
                                bp_ref_no: "",
                                start_due_date: null,
                                end_due_date: null,
                            };

                            setSearchValue(resetValues);
                            search({
                                ...resetValues,
                                page: 1,
                            });
                        }}
                    >
                        <X size={15} />
                    </Button>
                </OverlayTrigger>
            </Col>
        </>
    );
};
